import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface MarketplaceOfferState {}
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface MarketplaceOfferStore extends MarketplaceOfferState {}

const initialState: MarketplaceOfferState = {};

export const STORE_KEY_MARKETPLACE_OFFER = 'marketplace-offer-store';

export const useOfferStore = create<MarketplaceOfferStore>()(
    devtools(
        () => ({
            ...initialState,

            // TODO: Add state logic
        }),
        { name: STORE_KEY_MARKETPLACE_OFFER },
    ),
);
